"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUserData = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _api = require("../api");
var _contexts = require("../contexts");
var _utils = require("../utils");
const useUserData = params => {
  const {
    customerId
  } = (0, _contexts.useAppContext)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const isAnonymousUser = customerId === _auth.NOT_LOGGED_IN_USER_ID;
  const {
    data,
    error
  } = (0, _fetching.useSWR)(!isAnonymousUser ? [customerId, globalApiClient, tenant] : null, async () => (0, _api.getUserData)({
    customerId,
    globalApiClient,
    tenant
  }), {
    onSuccess: (0, _utils.onUserDataFetchSuccess)(params),
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  return {
    userData: data ?? {
      email: null,
      telephoneNumber: null
    },
    loading: !isAnonymousUser && data === undefined && error === undefined,
    error
  };
};
exports.useUserData = useUserData;